import React, { useState, useEffect, useContext } from "react";
import { Modal, Button } from "react-bootstrap";
import Select from "react-select";
import dayjs from "dayjs";
import DatePicker from "react-date-picker";
import "react-calendar/dist/Calendar.css";
import "react-date-picker/dist/DatePicker.css";
// import { AddUpdateProject, GetProjectModel } from 'services/Project/ProjectApi';
import Text_Editor from "./Text_Editor";
import { ERROR_MESSAGES } from "../components/GlobalMassage";
import { addUpdateBlog, GetBlogModal, GetcategoryLookup } from "../../Services/Blog/BlogApi";
import { useAuth } from "../../Context/AuthContext";
import SuccessPopupModal from "../components/SuccessPopupModal";

const AdminBlogAddUpdateModal = ({
  show,
  onHide,
  setIsAddUpdateActionDone,
  modelRequestData,
}) => {
  const [modelAction, setModelAction] = useState("");
  const [error, setErrors] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [categoryOption, setCategoryOption] = useState([]);
  const { setLoader, user } = useAuth()


  const [blogObj, setBlogObj] = useState({
    blogKeyID: null,
    title: null,
    slug: null,
    publishDate: null,
    featureImage: null,
    blogDescription: null,
    authorName: null,
    categoryID: null,
    slug: null,
    metaTitle: null,
    description:null
  });





  useEffect(() => {
    // debugger
    if (modelRequestData?.Action === 'Update') {
      if (modelRequestData?.BlogKeyID !== null) {
        GetBlogModalData(modelRequestData.BlogKeyID);
      }
    }
  }, [modelRequestData?.Action]);


  const AddCustomerBtnClick = async () => {
    let isValid = false;

    if (
      blogObj.title === null ||
      blogObj.title === undefined ||
      blogObj.title === "" ||
      blogObj.featureImage === null ||
      blogObj.featureImage === undefined ||
      blogObj.featureImage === "" ||
      blogObj.publishDate === null ||
      blogObj.publishDate === undefined ||
      blogObj.publishDate === "" ||
      blogObj.blogDescription === undefined ||
      blogObj.blogDescription === null ||
      blogObj.blogDescription === "" ||
      !blogObj.authorName ||
       !blogObj.slug
    


    ) {
      setErrors(true);
      isValid = true;
    } else {
      setErrors(false);
      isValid = false;
    }


    const apiParam = {
      blogKeyID: blogObj.blogKeyID,
      publishDate: blogObj.publishDate,
      title: blogObj.title,
      blogDescription: blogObj.blogDescription,
      featureImage: blogObj.featureImage,
      authorName: blogObj.authorName,
       slug: blogObj.slug,
    metaTitle: blogObj.metaTitle,
    description:blogObj.description

    };
    if (!isValid) {
      AddUpdateCustomerData(apiParam);
    }
  };

  const AddUpdateCustomerData = async (apiParam) => {
    // debugger
    setLoader(true);
    try {
      let url = '/addUpdateBlog'; // Default URL for Adding Data

      const response = await addUpdateBlog(url, apiParam);
      if (response) {
        if (response?.data?.statusCode === 200) {
          setLoader(false);
          // debugger
          setShowSuccessModal(true);
          setModelAction(
            modelRequestData.Action === null || modelRequestData.Action === undefined
              ? 'Blog Added Successfully!'
              : ' Blog Updated Successfully!'
          ); //Do not change this naming convention

          setIsAddUpdateActionDone(true);
        } else {
          setLoader(false);
          setErrorMessage(response?.response?.data?.errorMessage);
        }
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };


  const handleImageChange = (e, fieldName) => {
    const file = e.target.files[0];


    if (file) {


      if (file.size > 512000) {
        alert("Image size should be 500KB or less.");
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        setBlogObj(prev => ({
          ...prev,
          [fieldName]: reader.result, // set base64
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDateChange = (date) => {
    if (!date) {
      setBlogObj((prev) => ({
        ...prev,
        publishDate: null,
      }));
      return;
    }

    const formattedDate = dayjs(date).format("YYYY-MM-DD"); // Pure date string
    setBlogObj((prevState) => ({
      ...prevState,
      publishDate: formattedDate
    }));
  };
  const handleRemoveImage = (fieldName) => {
    setBlogObj(prev => ({
      ...prev,
      [fieldName]: null,
    }));
  };
  const GetBlogModalData = async (id) => {

    setLoader(true);
    if (id === undefined) {
      return;
    }

    try {
      const data = await GetBlogModal(id);
      if (data?.data?.statusCode === 200) {
        setLoader(false);

        console.log(data, 'dsadas324r');
        const ModelData = data.data.responseData.data; // Assuming data is an array

        setBlogObj({
          ...blogObj,
          title: ModelData.title,
          slug: ModelData.slug,
          publishDate: ModelData.publishDate,
          featureImage: ModelData.featureImage,
          metaTitle: ModelData.metaTitle,
          metaDescription: ModelData.metaDescription,
          blogDescription: ModelData.blogDescription,
          blogKeyID: ModelData.blogKeyID,

          featureImage: ModelData.featureImage,

        });

      } else {
        setLoader(false);
        // Handle non-200 status codes if necessary
        console.error('Error fetching data: ', data?.data?.statusCode);
      }
    } catch (error) {
      setLoader(false);
      console.error('Error in Customer : ', error);
    }
  };

  console.log(blogObj.Title, 'kdjsgauhydsa');

  const closeAllModal = () => {
    onHide();
    setShowSuccessModal(false);
  };

  const handleDescriptionChange = (htmlContent) => {
    setBlogObj((obj) => ({
      ...obj,
      blogDescription: htmlContent,
    }));
  };

  // const GetCategoryLookupListData = async () => {

  //     try {
  //       const response = await GetcategoryLookup(); 

  //       if (response?.data?.statusCode === 200) {
  //         const CategoryLookupList = response?.data?.responseData?.data || [];

  //         const formattedCategoryList = CategoryLookupList.map((cat) => ({
  //           value: cat.CategoryID,
  //           label: cat.CategoryName
  //         }));

  //         setCategoryOption(formattedCategoryList); 
  //       } else {
  //         console.error('Failed to fetch gallery Type lookup list:', response?.data?.statusMessage || 'Unknown error');
  //       }
  //     } catch (error) {
  //       console.error('Error fetching gallery Type lookup list:', error);
  //     }
  //   };





  return (
    <>
      {show && <div className="custom-backdrop" />}

      <Modal
        size="lg"
        show={show}
        style={{ zIndex: 1300 }}
        onHide={onHide}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h4 className="text-center text-dark">
              {modelRequestData?.Action !== null
                ? "Update Blog"
                : modelRequestData?.Action === null
                  ? "Add Blog"
                  : ""}
            </h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "55vh", overflow: "overlay" }}>
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-6 mb-2">
                <div>
                  <label htmlFor="clientName" className="form-label">
                    Title
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="clientName"
                    placeholder="Enter Title"
                    aria-describedby="Employee"
                    value={blogObj.title}
                    onChange={(e) => {
                      setErrorMessage(false);

                      const generatedSlug = e.target.value
                        .toLowerCase()
                        .trim()
                        .replace(/[^a-z0-9\s-]/g, "")
                        .replace(/\s+/g, "-");

                      let inputValue = e.target.value;
                      // If the input is empty or starts with a space, prevent the space
                      if (
                        inputValue.length === 0 ||
                        (inputValue.length === 1 && inputValue === " ")
                      ) {
                        inputValue = "";
                      }
                      // Remove unwanted characters (keeping spaces that aren't at the start)
                      const cleanedValue = inputValue.replace(
                        /[^a-zA-Z0-9\s]/g,
                        ""
                      );

                      // Trim leading spaces while keeping internal spaces
                      const trimmedValue = cleanedValue.trimStart();

                      // Capitalize the first letter and keep the rest as is
                      const updatedValue =
                        trimmedValue.charAt(0).toUpperCase() +
                        trimmedValue.slice(1);

                      setBlogObj((prev) => ({
                        ...prev,
                        title: updatedValue,
                        slug: generatedSlug,
                      }));
                    }}
                  />

                  {error &&
                    (blogObj.title === null ||
                      blogObj.title === undefined ||
                      blogObj.title === "") ? (
                    <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                  ) : (
                    ""
                  )}
                </div>
                </div>

<div className="col-12 col-md-6 mb-2">
                 <div>
                  <label htmlFor="clientName" className="form-label">
                    Slug
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="clientName"
                    placeholder="Example-blog-title"
                    aria-describedby="Employee"
                    value={blogObj.slug}
                    onChange={(e) => {
                      setErrorMessage(false);



                      let inputValue = e.target.value;
                      // If the input is empty or starts with a space, prevent the space
                      if (
                        inputValue.length === 0 ||
                        (inputValue.length === 1 && inputValue === " ")
                      ) {
                        inputValue = "";
                      }
                      // Remove unwanted characters (keeping spaces that aren't at the start)
                      const cleanedValue = inputValue.replace(
                        /[^a-zA-Z0-9\s]/g,
                        ""
                      );

                      // Trim leading spaces while keeping internal spaces
                      const trimmedValue = cleanedValue.trimStart();

                      // Capitalize the first letter and keep the rest as is
                      const updatedValue =
                        trimmedValue.charAt(0).toUpperCase() +
                        trimmedValue.slice(1);

                      setBlogObj((prev) => ({
                        ...prev,
                        slug: updatedValue,

                      }));
                    }}
                  />

                  {error &&
                    (blogObj.slug === null ||
                      blogObj.slug === undefined ||
                      blogObj.slug === "") ? (
                    <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                  ) : (
                    ""
                  )}

                </div>
                </div>


              </div>
              



            <div className="row">
              <div className="col-12 col-md-6 mb-2">
                <div>
                  <label htmlFor="clientName" className="form-label">
                    Author
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="clientName"
                    placeholder="Enter Author Name"
                    aria-describedby="Employee"
                    value={blogObj.authorName}
                    onChange={(e) => {
                      setErrorMessage(false);
                      let inputValue = e.target.value;
                      // If the input is empty or starts with a space, prevent the space
                      if (
                        inputValue.length === 0 ||
                        (inputValue.length === 1 && inputValue === " ")
                      ) {
                        inputValue = "";
                      }
                      // Remove unwanted characters (keeping spaces that aren't at the start)
                      const cleanedValue = inputValue.replace(
                        /[^a-zA-Z0-9\s]/g,
                        ""
                      );

                      // Trim leading spaces while keeping internal spaces
                      const trimmedValue = cleanedValue.trimStart();

                      // Capitalize the first letter and keep the rest as is
                      const updatedValue =
                        trimmedValue.charAt(0).toUpperCase() +
                        trimmedValue.slice(1);

                      setBlogObj((prev) => ({
                        ...prev,
                        authorName: updatedValue,
                      }));
                    }}
                  />

                  {error &&
                    (blogObj.authorName === null ||
                      blogObj.authorName === undefined ||
                      blogObj.authorName === "") ? (
                    <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                  ) : (
                    ""
                  )}

                </div>
              </div>
              {/* <div className="col-12 col-md-6 mb-2">
                <div>
                  <label htmlFor="clientName ">
                    Select  Category
                  </label>
                  <Select
                    options={categoryOption}
                    value={categoryOption.find(option => option.value === blogObj.categoryID) || null}
                    onChange={(selectedOption) => {
                      setBlogObj(prev => ({
                        ...prev,
                        categoryID: selectedOption?.value || null
                      }));
                    }}
                  />
                </div>
              </div> */}
            </div>

            <div className="row">
              

              <div className="col-12 col-md-6 mb-2">
                <div>

                  <label htmlFor="clientName" className="form-label">
                    Meta Title
                    
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="clientName"
                    placeholder="SEO meta title"
                    aria-describedby="Employee"
                    value={blogObj.metaTitle}
                    onChange={(e) => {
                      setErrorMessage(false);



                      let inputValue = e.target.value;
                      // If the input is empty or starts with a space, prevent the space
                      if (
                        inputValue.length === 0 ||
                        (inputValue.length === 1 && inputValue === " ")
                      ) {
                        inputValue = "";
                      }
                      // Remove unwanted characters (keeping spaces that aren't at the start)
                      const cleanedValue = inputValue.replace(
                        /[^a-zA-Z0-9\s]/g,
                        ""
                      );

                      // Trim leading spaces while keeping internal spaces
                      const trimmedValue = cleanedValue.trimStart();

                      // Capitalize the first letter and keep the rest as is
                      const updatedValue =
                        trimmedValue.charAt(0).toUpperCase() +
                        trimmedValue.slice(1);

                      setBlogObj((prev) => ({
                        ...prev,
                        metaTitle: updatedValue,

                      }));
                    }}
                  />

                 

                </div>
              </div>

              <div className="col-12 col-md-6 mb-2">
              <label htmlFor="Description" className="form-label">
                                  Meta Description
                                  
                                </label>
                                <textarea
                                  type="textarea"
                                  className="form-control"
                                  id="Description"
                                  placeholder="Enter Meta Description"
                                  aria-describedby="Employee"
                                  value={blogObj.description}
                                  onChange={(e) => {
                                    setErrorMessage(false);
                                    let inputValue = e.target.value;
                                    // If the input is empty or starts with a space, prevent the space
                                    if (
                                      inputValue.length === 0 ||
                                      (inputValue.length === 1 && inputValue === " ")
                                    ) {
                                      inputValue = "";
                                    }
                                    // Remove unwanted characters (keeping spaces that aren't at the start)
                                    const cleanedValue = inputValue.replace(
                                      /[^a-zA-Z0-9\s]/g,
                                      ""
                                    );
              
                                    // Trim leading spaces while keeping internal spaces
                                    const trimmedValue = cleanedValue.trimStart();
              
                                    // Capitalize the first letter and keep the rest as is
                                    const updatedValue =
                                      trimmedValue.charAt(0).toUpperCase() +
                                      trimmedValue.slice(1);
              
                                    setBlogObj((prev) => ({
                                      ...prev,
                                      description: updatedValue,
                                    }));
                                  }}
                                />
              
                               
</div>
            </div>

            



            <div className="row">
              <div className="col-12 col-md-6 mb-2">
                <div>
                  <label htmlFor="customerAddress" className="form-label">
                    Publish Date
                    <span style={{ color: "red" }}>*</span>
                  </label>

                  <DatePicker
                    value={blogObj?.publishDate ? new Date(blogObj.publishDate) : null}
                    onChange={handleDateChange}
                    clearIcon={null}
                    calendarIcon={null}
                    maxDate={new Date()}
                  />
                  {error &&
                    (blogObj.publishDate === null ||
                      blogObj.publishDate === undefined ||
                      blogObj.publishDate === "") ? (
                    <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <div className="col-12 col-md-6 mb-2">
                <label className="form-label">Feature Image:
                  <p className="small">Note:-(Upto 200kb) </p>
                </label>
                {blogObj.featureImage ? (
                  <div style={{ position: 'relative', display: 'inline-block' }}>
                    <img
                      src={blogObj.featureImage}
                      alt="Feature Preview"
                      style={{
                        maxWidth: '100%',
                        maxHeight: '200px',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                      }}
                    />
                    <button
                      type="button"
                      onClick={() => handleRemoveImage('featureImage')}
                      style={{
                        position: 'absolute',
                        top: '5px',
                        right: '5px',
                        background: 'rgba(255,255,255,0.8)',
                        border: 'none',
                        borderRadius: '50%',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        padding: '2px 8px',
                      }}
                    >
                      ×
                    </button>
                  </div>
                ) : (
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleImageChange(e, 'featureImage')}
                    className="form-control"
                  />
                )}
              </div>



            </div>



            {/* <div className="row"> */}
          </div>
          <div className="row">
            <div className="col-12 mb-4 ">
              <div>
                <label htmlFor="aboutUs" className="form-label">
                  Blog Description
                  <span style={{ color: "red" }}>*</span>
                </label>
                <Text_Editor
                  editorState={blogObj.blogDescription}
                  handleContentChange={handleDescriptionChange}
                />
                {error &&
                  (blogObj.blogDescription === null ||
                    blogObj.blogDescription === undefined ||
                    blogObj.blogDescription === "") ? (
                  <span style={{ color: "red" }}>{ERROR_MESSAGES}</span>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>

          {/* </div> */}
        </Modal.Body>
        <Modal.Footer>
          <Button className="rts-btn border bg-transparent" onClick={onHide}>
            Close
          </Button>
          <Button
            type="submit"
            style={{
              color: "white",
              backgroundColor: "#blue",
              borderColor: "#f08143",
            }}
            className=" rts-btn    text-center"
            onClick={() => AddCustomerBtnClick()}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
      {showSuccessModal && (
        <SuccessPopupModal
          show={showSuccessModal}
          onHide={() => closeAllModal()}
          setShowSuccessModal={setShowSuccessModal}
          modelAction={modelAction}
        />
      )}
    </>
  );
};

export default AdminBlogAddUpdateModal;
